import { useState, useCallback } from 'react';

export default function useAdminPasswordAccess() {
  const [hasAccountingAccess, setHasAccountingAccess] = useState(false);
  const [hasReportsAccess, setHasReportsAccess] = useState(false);
  const [hasPaymentsAccess, setHasPaymentsAccess] = useState(false);
  const [hasAdminAccess, setHasAdminAccess] = useState(false);

  // Grant access to accounting area
  const grantAccountingAccess = useCallback(() => {
    setHasAccountingAccess(true);
  }, []);

  // Grant access to reports area
  const grantReportsAccess = useCallback(() => {
    setHasReportsAccess(true);
  }, []);

  // Grant access to payments area
  const grantPaymentsAccess = useCallback(() => {
    setHasPaymentsAccess(true);
  }, []);

  // Grant general admin access
  const grantAdminAccess = useCallback(() => {
    setHasAdminAccess(true);
  }, []);

  // Check if admin has access to specific area
  const hasAccess = useCallback((area) => {
    switch (area) {
      case 'accounting':
        return hasAccountingAccess;
      case 'reports':
        return hasReportsAccess;
      case 'payments':
        return hasPaymentsAccess;
      case 'admin':
        return hasAdminAccess;
      default:
        return false;
    }
  }, [hasAccountingAccess, hasReportsAccess, hasPaymentsAccess, hasAdminAccess]);

  // Clear all access (useful for logout)
  const clearAllAccess = useCallback(() => {
    setHasAccountingAccess(false);
    setHasReportsAccess(false);
    setHasPaymentsAccess(false);
    setHasAdminAccess(false);
  }, []);

  return {
    hasAccountingAccess,
    hasReportsAccess,
    hasPaymentsAccess,
    hasAdminAccess,
    grantAccountingAccess,
    grantReportsAccess,
    grantPaymentsAccess,
    grantAdminAccess,
    hasAccess,
    clearAllAccess
  };
}
